import lightTheme from './light';
import { darkPalette } from './palette';

const darkTheme = {
  ...lightTheme,
  palette: darkPalette,
};

export default darkTheme;
